<template>
  <v-container>
    <!-- <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    
    <v-data-table
      dense
      class="elevation-1"
      :headers="headers"
      :items="groups"
      item-key="name"
      hide-default-footer
      :items-per-page="-1"
      loading-text="ローディング..."
      no-data-text="該当データがありません。"
      :sort-by="['name']"
      :sort-desc="[false]"
      @click:row="(item) => {
        viewDetail(item)
      }"
    >
    <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>グループ一覧</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="role==='ADMIN'" color="primary" dark class="mb-2" @click="addGroup()">
            <v-icon left>mdi-plus-box</v-icon>グループ登録
          </v-btn>
        </v-toolbar>
    </template>
    <template v-slot:item.first_name="{item}">
      {{ item.last_name }} {{ item.first_name }}
    </template>
    <template v-slot:item.status="{item}">
      <v-switch
        readonly
        :input-value="item.status=='ACTIVE'? true : false"
        v-if="role==='ADMIN'"
        color="success"
        @click.stop="confirmActiveGroup(item)"
      ></v-switch>
      <v-chip
        class="ma-2"
        color="green"
        text-color="white"
        v-if="item.status=='ACTIVE' && role!='ADMIN'"
      >
        有効
      </v-chip>
      <v-chip
        class="ma-2"
        color="red"
        text-color="white"
        v-if="item.status=='DEACTIVE' && role!='ADMIN'"
      >
        無効
      </v-chip>
    </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {store} from '../store';

export default {
  name: "Group",
  data() {
    return {
      role: localStorage.getItem('drs_role'),
      loading: true,
      groups: [],
      users: [],
      allplants: [],
      checkActive: null,
      headers: [],
      // headers: [
      //   {
      //     text: '名前',
      //     value: 'name',
      //     align: 'left',
      //   },
      //   {
      //     text: 'オーナー',
      //     value: 'first_name',
      //     align: 'left',
      //   },
      //   {
      //     text: '状況',
      //     value: 'status',
      //     align: 'left',
      //     sortable: false,
      //   },
      //   {
      //     text: '',
      //     value: 'actions',
      //     sortable: false,
      //   },
      // ],
    }
  },

  methods: {
    resetHeaders() {
      if (this.role == 'ADMIN') {
        this.headers.push(
          {
            text: '名前',
            value: 'name',
            align: 'left',
          },
          {
            text: 'オーナー',
            value: 'first_name',
            align: 'left',
          },
          {
            text: '有効',
            value: 'status',
            align: 'left',
            sortable: false,
          },
        )
      } else {
        this.headers.push(
          {
            text: '名前',
            value: 'name',
            align: 'left',
          },
          {
            text: 'オーナー',
            value: 'first_name',
            align: 'left',
          },
          {
            text: '状況',
            value: 'status',
            align: 'center',
            sortable: false,
          },
        )
      }
    },
    resetData() {
        this.loading = true;
        this.groups = [];
    },

    getGroups() {
        this.resetData();
        this.axios.get("/api/group/")
        .then((response) => {
            this.loading = false;
            this.groups = response.data;
        })
        .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
        });
    },

    getUsers() {
        this.users = [];
        this.axios.get("/api/group/get-user/")
        .then((response) => {
            this.users = response.data;
        })
        .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
        }); 
    },

    getAllPlants() {
      this.allplants = [];
      this.axios.get("/api/group/all-plants/")
      .then((response) => {
        this.allplants = response.data;
      })
      .catch(() => {
        store.showErrorDialog("error");
      })
    },

    addGroup() {
      this.$router.push('/group/add');
    },

    getStatusText(value) {
        const statuses = [
            { text: "無効", value: "ACTIVE"},
            { text: "有効", value: "DEACTIVE"},
        ];
        const status = statuses.find(x => x.value == value);
        return status ? status.text : '';
    },
    confirmActiveGroup(item) {
      console.log(item);
      const confirmDialog = {
        title: this.getStatusText(item.status)+'にする確認',
        content: this.getStatusText(item.status)+"になります。よろしいですか。",
        onAgree: () => this.activeGroup(item),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },

    activeGroup(item) {
        if (item.status === 'ACTIVE') {
            this.checkActive = "DEACTIVE";
        } else {
            this.checkActive = "ACTIVE";
        }
        store.showLoadingOverlay(true);
        this.axios.put("/api/group/active/"+ item.id, {status: this.checkActive,})
        .then(() => {
          this.getGroups();
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        })
        .then(() => {
          store.showLoadingOverlay(false);
        });
    },

    viewDetail(item) {
      this.$router.push('/group/'+item.id);
    },

    customSort(items, index) {
      items.sort((a, b) => {
        if (index[0] === 'name') {
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
        }
      });
      return items;
    }
  },

  created() {
    this.getGroups();
  },
  mounted() {
    this.resetHeaders();
  },
}
</script>

<style scoped>
>>>.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
>>>.v-input__slot {
  margin-bottom: 0px;
}
>>>.v-input--selection-controls {
  margin-top: 0px;
}
>>>.v-input--selection-controls.v-input--dense .v-input--selection-controls__ripple {
  width: 0px;
  height: 0px;
}
>>>.v-input--selection-controls__ripple {
  height: 0px;
}
>>> tbody tr :hover {
  cursor: pointer;
}
</style>
